import React from 'react';

export const BrickContext = React.createContext({});

export const BrickContextProvider = ({ children, ...props }) => (
  <BrickContext.Provider {...props}>{children}</BrickContext.Provider>
);
